module.exports = __webpack_public_path__ + "static/media/unlockBanner.22cdc1bf.png";